import { Link } from "react-router-dom";

const Shell = ({ title, children }) => (
  <div className="min-h-screen bg-[#F8FAFC]">
    <header className="border-b border-[#E2E8F0] bg-white">
      <div className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-md bg-[#0A2342] flex items-center justify-center">
            <span className="text-[#4FD1C5] font-heading font-bold text-xs">D</span>
          </div>
          <span className="font-heading font-bold text-[14px] text-[#0A2342]">Dive Media Strategist™</span>
        </Link>
        <Link to="/" className="text-[13.5px] text-[#1D4E89] hover:text-[#0A2342]">← Home</Link>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-10 py-12 sm:py-16">
      <div className="dms-label mb-3">Legal · Draft pending legal review</div>
      <h1 className="text-3xl sm:text-4xl font-heading font-bold text-[#0A2342]">{title}</h1>
      <div className="mt-8 prose prose-slate max-w-none text-[#1F2937] text-[15px] leading-relaxed">
        {children}
      </div>
    </main>
  </div>
);

const para = (s) => s.split("\n\n").map((p, i) => p.startsWith("## ") ? <h2 key={i} className="font-heading font-bold text-xl text-[#0A2342] mt-8 mb-3">{p.replace(/^## /, "")}</h2> : <p key={i} className="my-4">{p}</p>);

export function Terms() {
  return <Shell title="Terms & Conditions">{para(`Last updated: ${new Date().toLocaleDateString()}.

## 1. Acceptance
By using Dive Media Strategist™ ("DMS", "we", "us") you agree to these Terms. If you do not agree, do not use the service.

## 2. The Service
DMS provides AI-assisted marketing tools for the diving industry. Outputs are generated based on inputs you provide and the Dive Intelligence Layer doctrine. You are responsible for reviewing and editing every output before publication.

## 3. Account & Eligibility
You must be 18+ and provide accurate information. You are responsible for keeping your password confidential.

## 4. Subscriptions, Trials & Billing
We offer 7-day free trials, monthly subscriptions, one-time consulting bookings, and optional query packs. Subscriptions renew until cancelled. You may cancel any time from your Billing settings.

## 5. Acceptable Use
You agree not to: (a) generate unlawful, infringing, defamatory or fraudulent content; (b) reverse engineer the platform or extract our proprietary doctrine; (c) resell outputs as a standalone product without substantial modification.

## 6. Intellectual Property
You retain all rights to outputs you generate for your own business. The DMS platform, brand, Dive Intelligence Layer and Dive Brain framework remain our property.

## 7. AI Outputs Disclaimer
AI outputs may contain errors. You are responsible for fact-checking and editing all outputs. We do not warrant that outputs are accurate, suitable for purpose, or compliant with platform policies.

## 8. Limitation of Liability
To the maximum extent permitted by law, our aggregate liability is limited to the amounts you paid us in the preceding 12 months.

## 9. Termination
We may suspend or terminate accounts for material breach. You may delete your account from Settings at any time.

## 10. Governing Law
These Terms are governed by the laws of Malta. Disputes will be resolved in Maltese courts.

## 11. Contact
Questions: hello@divemediastrategist.com

This document is a draft pending review by qualified legal counsel.`)}</Shell>;
}

export function Privacy() {
  return <Shell title="Privacy Policy">{para(`Last updated: ${new Date().toLocaleDateString()}.

## 1. Who we are
Dive Media Strategist™ is operated from Malta. Contact: hello@divemediastrategist.com.

## 2. Data we collect
Account data (name, email, password hash). Usage data (which tools you use, when). Generated content stored in your Content Vault. Optional uploads (images and brand guides). Payment metadata via Stripe (we do not store card numbers).

## 3. Why we process it
To operate the service, authenticate you, generate outputs, process payments, communicate updates, and improve the product.

## 4. Lawful basis (GDPR)
Performance of contract (account, service delivery), legitimate interest (analytics, security), consent (marketing emails, non-essential cookies).

## 5. Sub-processors
We use the following third-party processors: Stripe (payments), Anthropic via Emergent (AI generation), Brevo (transactional & marketing email - when enabled), Cloud object storage (file storage), MongoDB Atlas / equivalent (database).

## 6. International transfers
Some sub-processors are located outside the EEA. Transfers are protected by Standard Contractual Clauses where required.

## 7. Your rights
Access, rectification, erasure, portability, restriction, objection. Email hello@divemediastrategist.com with your request - we respond within 30 days. You can also delete your account from Settings.

## 8. Cookies
We use essential cookies for authentication and optional analytics cookies if you accept them. See the cookie banner.

## 9. Retention
Account data: while active + 12 months after deletion request. Content Vault: until you delete or close your account.

## 10. Children
The service is not intended for under-18s.

## 11. Changes
We will notify you of material changes by email or in-app banner.

This document is a draft pending review by qualified legal counsel.`)}</Shell>;
}

export function Disclaimer() {
  return <Shell title="Disclaimer">{para(`Last updated: ${new Date().toLocaleDateString()}.

## AI Generated Content
DMS uses AI models to generate marketing copy and structure. Outputs are suggestions, not professional advice. You are responsible for reviewing, editing and verifying every output before publication.

## No Guaranteed Results
We make no guarantees about audience growth, engagement, revenue, or business outcomes. Results depend on many factors outside our control, including your offer, audience, timing, execution and platform algorithms.

## Affiliate Disclosure
Our Downloads / Resource Library may contain affiliate links. If you sign up for a recommended tool through these links, we may earn a commission at no extra cost to you. We only recommend tools we use ourselves.

## Diving Safety
Nothing in DMS constitutes diving instruction, medical advice or safety guidance. Always follow your certifying agency's standards and your local regulations.

## External Links
We may link to external websites. We are not responsible for their content or policies.

This document is a draft pending review by qualified legal counsel.`)}</Shell>;
}

export default Terms;
